import { Link } from "react-router-dom";
import { Ship, Wrench, GraduationCap, Megaphone, ArrowRight, ArrowUpRight } from "lucide-react";
import { Reveal, Chapter } from "@/components/Reveal";
import { BENEFITS, STEPS, APPLY_PATH } from "@/data/content";

const BENEFIT_ICONS = [Ship, Wrench, GraduationCap, Megaphone];

export const Program = () => (
  <>
    <section id="program" className="relative py-24 lg:py-32" data-testid="program-section">
      <div className="container-x">
        <Reveal>
          <Chapter index="01" label="Partnership Value" />
          <div className="grid items-end gap-6 lg:grid-cols-[1.5fr_1fr]">
            <h2 className="font-display text-2xl font-bold tracking-tight text-offwhite sm:text-3xl lg:text-4xl">
              A Premium Attraction <span className="text-aqua">Without the Equipment Purchase</span>
            </h2>
            <p className="text-base leading-relaxed text-muted lg:justify-self-end lg:text-right">
              The program is built so experienced waterfront operators can launch a headline attraction while Xtreme
              Exotics carries the asset side of the operation.
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4">
          {BENEFITS.map((b, i) => {
            const Icon = BENEFIT_ICONS[i];
            return (
              <Reveal key={b.title} delay={i * 0.08}>
                <div
                  className="card-line group relative h-full overflow-hidden rounded-xl p-7"
                  data-testid={`benefit-card-${i}`}
                >
                  <div className="absolute -right-10 -top-10 h-28 w-28 rounded-full bg-aqua/0 blur-2xl transition-colors duration-700 group-hover:bg-aqua/15" />
                  <span className="grid h-11 w-11 place-items-center rounded-lg border border-aqua/25 bg-aqua/10 text-aqua">
                    <Icon size={20} strokeWidth={1.8} />
                  </span>
                  <h3 className="mt-6 font-display text-lg font-bold leading-snug text-offwhite">{b.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-muted">{b.body}</p>
                  <span className="mt-6 block h-px w-full bg-gradient-to-r from-aqua/40 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>

    <section id="how-it-works" className="relative bg-charcoal/30 py-24 lg:py-32" data-testid="how-it-works-section">
      <div className="container-x">
        <Reveal>
          <Chapter index="02" label="How the Partnership Works" />
          <h2 className="max-w-2xl font-display text-2xl font-bold tracking-tight text-offwhite sm:text-3xl lg:text-4xl">
            From Application to Launch, in Four Steps
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.1}>
              <div className="group relative" data-testid={`step-card-${i + 1}`}>
                <span className="font-display text-6xl font-extrabold text-black/[0.06] transition-colors duration-500 group-hover:text-aqua/20 lg:text-7xl">
                  0{i + 1}
                </span>
                <div className="mt-2 border-l-2 border-aqua/30 pl-5 transition-colors duration-500 group-hover:border-aqua">
                  <h3 className="font-display text-lg font-bold text-offwhite">{s.title}</h3>
                  <p className="mt-2.5 text-sm leading-relaxed text-muted">{s.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2} className="mt-14">
          <Link to={APPLY_PATH} className="btn-primary" data-testid="how-it-works-apply-btn">
            Apply Now <ArrowUpRight size={16} />
          </Link>
        </Reveal>
      </div>
    </section>
  </>
);

export const ProgramArrow = ArrowRight;
